export default "__VITE_ASSET__CuiPkLeC__"